export const light = 'light';
export const dark = 'dark';
